// Official BCM brand assets.
//
// The official logo and wordmark must never be redrawn or reinterpreted. Paste
// the hosted URLs of the supplied files below and every logo on the site
// updates at once. While a URL is empty, the site renders a plain typographic
// placeholder rather than an imitation of the official mark.

export type BrandAssetKey =
  | 'wordmarkBlue'
  | 'wordmarkWhite'
  | 'wordmarkTan'
  | 'logoCompactBlue'
  | 'logoCompactWhite'

export const brandAssets: Record<BrandAssetKey, string> = {
  wordmarkBlue: '',
  wordmarkWhite: '',
  wordmarkTan: '',
  logoCompactBlue: '',
  logoCompactWhite: '',
}
